import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Input,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector:
        'button[cmpsCoachingFocusLabelButton], a[cmpsCoachingFocusLabelAnchor]',
    template: ` <cmps-coaching-focus-label
        [statusLabel]="statusLabel"
        [behaviourLabel]="behaviourLabel"
        [behaviour]="behaviour"
        [subBehaviourLabel]="subBehaviourLabel"
        [subBehaviour]="subBehaviour"
    ></cmps-coaching-focus-label>`,
    host: {
        class: 'cmps-coaching-focus-label-action',
        '[class.cmps-coaching-focus-label-action--button]':
            '_el.nativeElement.tagName.toLowerCase() === "button"',
        '[class.cmps-coaching-focus-label-action--anchor]':
            '_el.nativeElement.tagName.toLowerCase() === "a"',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmpsFocusLabelActionComponent {
    @Input() statusLabel: string;
    @Input() behaviourLabel: string;
    @Input() behaviour: string;
    @Input() subBehaviourLabel: string;
    @Input() subBehaviour: string;

    constructor(/** @private */ public readonly _el: ElementRef<HTMLElement>) {}
}
